import type { ReactNode } from "react";
import { useState } from "react";
import styled from "@emotion/styled";
import {mediaBelow, duration, interactive, surface} from "@atlas-int/tokens";

const ToggleWrapper = styled.div`
  border: 1px solid ${interactive.muted};
  padding: 1em;
  margin-right: 1em;
  background-color: ${surface.panel};

  ${mediaBelow("md")} {
    border: none;
    background-color: transparent;
  }
`;

const ToggleButton = styled.button`
  font-family: inherit;
  cursor: pointer;
  background: none;
  border: none;
  color: inherit;
  font-size: inherit;
  padding: 0;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;

  &::before {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    margin-right: 0.4rem;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 6px solid #000;
    transition: transform ${duration.fast} ease;
  }

  &[data-open="true"]::before {
    transform: rotate(90deg);
  }

  ${mediaBelow("md")} {
    align-items: flex-start;

    &::before {
      margin-top: 0.5rem;
    }
  }
`;

export default function Toggle({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <ToggleWrapper>
      <ToggleButton
        aria-expanded={open}
        aria-label={open ? "Hide content" : "Show content"}
        data-open={open}
        onClick={() => setOpen((s) => !s)}
      >
        <span className="italic">
          {label}
        </span>
      </ToggleButton>

      {open && <div>{children}</div>}
    </ToggleWrapper>
  );
}
